import React from 'react'
import LeftSideBar from '../../components/LeftSideBar';
import Title from '../../components/Title';
import { Link } from 'react-router-dom';

export const Incorporation = () => {
  return (
    <div className='container services_main_wrapper'>
        <div className='row mt-5 mb-5'>
            <div className='col-md-3  column_height'>
               <LeftSideBar/>
            </div>
            <div className='col-md-9'>
               <div className='right_side_content'>
                    <div className='section_main_title d-flex align-items-center justify-content-between'>
                        <div className='title_and_icon d-flex align-items-center'>
                            <img src='/images/incorporation.png'></img>
                            <Title text="INCORPORATION" className="custom-heading" />
                        </div>
                        <ul className='d-flex align-items-center'>
                          <li className='light-blue'>transforming ideas into businesses with ease</li>
                        </ul>
                    </div>
                    <p>One of the key decisions to be made while starting a business is to choose the right business vehicle for it. This decision depends on multiple factors ranging from whether the business requires capital infusion through equity investors, what are the number of founders, what is the compliance cost, etc. among many other considerations. It lays down the foundation for the organization with respect to the formation of the legal entity through which to run the business and the future of the compliances related to such entity.</p>
                    <p>Selecting the appropriate entity type is not just about complying with legal formalities; it is about making strategic decisions that will affect your business’s operations, growth potential, and regulatory obligations. Factors such as capital requirements, the number of founders, liability concerns, and compliance costs must be considered. </p>
                    <div className='row'>
                        <div className='col-md-7'>
                            <div className='list_view'>
                                <h4>There are six primary types of business entities you can choose from:</h4>
                                <ul className='p-0'>
                                    <li><Link to="/sole-proprietorship">Sole Proprietorship</Link></li>
                                    <li><Link to="/partnership-firm">Partnership Firm</Link></li>
                                    <li><Link to="/limited-liability">Limited Liability Partnership (LLP)</Link></li>
                                    <li><Link to="/one-person-company">One Person Company (OPC)</Link></li>
                                    <li><Link to="/private-limited-company">Private Limited Company</Link></li>
                                    <li><Link to="/public-limited-company">Public Limited Company</Link></li>
                                </ul>
                                <p>At <strong>Vanani & Associates,</strong> we understand that the journey from a great idea to a successful business starts with proper incorporation. Our comprehensive incorporation services are designed to simplify this process, ensuring that your business is set up for success from the very beginning.</p>
                            </div>
                        </div>
                        <div className='col-md-5'>
                            <div className='box_shadow'>
                               <img className='img_width' src='/images/Incorporation_small.png' alt='incorporations'></img>
                            </div>
                        </div>  
                    </div>
                   
                    <div className='main_back_clr p-4 mt-4 check_list_wrap'>
                        <h4 class="mb-2 font-weight-600">Our Comprehensive<sapn class="key_features"> Incorporation Services</sapn></h4>
                        <div className='space'>
                           <p>We provide end-to-end incorporation services to ensure a smooth and hassle-free process:</p>
                        </div>
                        <ul className='p-0'>
                            <li>
                                <p><strong>Business Structure Advisory: </strong> We assist you in choosing the most suitable business structure based on your specific needs and strategic goals.</p>
                            </li>
                            <li>
                                <p><strong>Name Approval: </strong>We help secure the name of your choice, ensuring it complies with regulatory standards.</p>
                            </li>
                            <li>
                                <p><strong>Document Preparation: </strong>Drafting and filing essential documents, including Deeds, MOA and AOA for companies.</p>
                            </li>
                            <li>
                                <p><strong>Digital Signature Certificate (DSC) and Director Identification Number (DIN): </strong> We facilitate obtaining DSC and DIN for directors.</p>
                            </li>
                            <li>
                                <p><strong>Incorporation Filing: </strong> Submitting incorporation forms and documents to the Registrar of Firms (ROF), the Registrar of Companies (RoC) and following up until the Certificate of Incorporation is issued.</p>
                            </li>
                            <li>
                                <p><strong>Post-Incorporation Compliance: </strong> Providing guidance on post-incorporation requirements such as PAN, TAN, GST registration, and more.</p>
                            </li>
                        </ul>
                    </div>
               </div>
            </div>
        </div>
    </div>
  )
}

export default Incorporation;